import { Injectable } from '@angular/core';
import { LiteratureDataService } from '@literature/services/literature-data.service';
import { SegmentService } from '@services/segment.service';
import {
  LiteratureData,
  LiteratureDocument,
  LiteratureDocumentData,
  SegmentId,
} from '@types';
import { map, shareReplay } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ComplimentaryLiteratureService {
  constructor(
    private literatureDataService: LiteratureDataService,
    protected segmentService: SegmentService
  ) {}
  populate(
    params: Map<string, string>,
    useCache = false
  ): Observable<LiteratureDocument> {
    return this.literatureDataService.loadData(params, useCache, true).pipe(
      map((data: LiteratureData) => {
        if (data !== null) {
          return this.modifyDetailData(data.document[0]);
        }
      }),
      shareReplay(1)
    );
  }
  /**
   *
   * @param params litCode
   * @returns literature documents for that litCode
   */
  getTumbnailItems(
    params: Map<string, string>
  ): Observable<LiteratureDocument[]> {
    return this.literatureDataService.loadData(params, false, true).pipe(
      map((data: LiteratureData) =>
        data.document.map((item) => this.modifyDetailData(item))
      ),
      shareReplay(1)
    );
  }
  modifyDetailData(data: LiteratureDocumentData): LiteratureDocument {
    const detailData = this.literatureDataService.literatureMapper(data);
    this.literatureDataService.mapLiteratureUrl(detailData);
    if (SegmentId.INVESTOR === this.segmentService.getCurrentSegmentId()) {
      detailData.isInvestor = true;
    }
    return detailData;
  }
}
